import React, { createRef, useEffect, useMemo, useState } from 'react';
import { SnackbarProvider } from 'notistack';
import { IntlProvider } from 'react-intl';
import LanguageContext from './contexts/languageContext';
import { messages as enMessages } from './lang/en';
import { messages as faMessages } from './lang/fa';
import { makeStyles } from '@material-ui/core';
import MessagesContext from './contexts/messagesContext';
import { CrossIcon } from './components/UI/Images/Icons';
import { getSettingItem } from './utils/storage';
import Routes from './Routes/index';
import * as Sentry from '@sentry/react';
import { DBConfig } from './components/AllPatients/DBConfig';
import { initDB } from 'react-indexed-db';

const styles = makeStyles({
    rtlMainContainer: {
        direction: 'rtl',
        textAlign: 'right',
        fontFamily: 'mainFont'
    },
    ltrMainContainer: {
        direction: 'ltr',
        textAlign: 'left',
        fontFamily: 'mainFont'
    },
    closeIconContainer: {
        cursor: 'pointer'
    },
    snackAction: {
        marginInlineEnd: '-2px',
        paddingInlineStart: '12px',
        marginRight: 'auto',
        paddingLeft: '0'
    },
    snackContentRoot: {
        fontFamily: 'inherit'
    }
});
// const rtlTheme = createMuiTheme({
//     override: {
//         MuiDialog: {
//             root: {
//                 direction: 'rtl'
//             }
//         }
//     }
// });
// const ltrTheme = createMuiTheme({
//     override: {
//         MuiDialog: {
//             root: {
//                 direction: 'ltr'
//             }
//         }
//     }
// });
initDB(DBConfig);
const App = () => {
    const notistackRef = createRef();

    const onClickDismiss = (key) => () => {
        notistackRef.current.closeSnackbar(key);
    };
    const savedLang = getSettingItem('lang');
    const [lang, setLang] = useState(savedLang ? savedLang : 'fa');
    const [messages, setMessages] = useState(enMessages);
    const languageContextProvider = useMemo(
        () => ({
            lang,
            setLang,
            messages,
            setMessages
        }),
        [lang, setLang, messages, setMessages]
    );
    const messagesContextProvider = useMemo(
        () => ({
            messages,
            setMessages
        }),
        [messages, setMessages]
    );
    const classes = styles({ rtl: lang === 'fa' });
    useEffect(() => {
        if (lang) {
            setLang(lang);
            if (lang === 'en') {
                setMessages(enMessages);
            } else {
                setMessages(faMessages);
            }
        }
    }, [lang]);

    return (
        // <ThemeProvider theme={lang === 'fa' ? rtlTheme : ltrTheme}>
        <main className={lang === 'fa' ? classes.rtlMainContainer : classes.ltrMainContainer}>
            <LanguageContext.Provider value={languageContextProvider}>
                <MessagesContext.Provider value={messagesContextProvider}>
                    <IntlProvider defaultLocale="fa" locale={lang} messages={messages}>
                        <SnackbarProvider
                            classes={{
                                action: classes.snackAction,
                                contentRoot: classes.snackContentRoot
                            }}
                            ref={notistackRef}
                            maxSnack={3}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            preventDuplicate
                            dir="auto"
                            action={(key) => (
                                <div
                                    className={classes.closeIconContainer}
                                    onClick={onClickDismiss(key)}
                                >
                                    <CrossIcon fill={'#fff'} />
                                </div>
                            )}
                            iconVariant={{
                                error: ''
                            }}
                        >
                            <Routes />
                        </SnackbarProvider>
                    </IntlProvider>
                </MessagesContext.Provider>
            </LanguageContext.Provider>
        </main>

        // </ThemeProvider>
    );
};
export default Sentry.withProfiler(App);
